import { render, staticRenderFns } from "./ReversionPage.vue?vue&type=template&id=510f1e14"
import script from "./ReversionPage.js?vue&type=script&lang=js&external"
export * from "./ReversionPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports